<template>
  <div class="">
    <DataGetter
      @dataAvailable="
        data => {
          payments = data
          this.isLoading = false
        }
      "
      contentId="payments"
    />

    <div
      class="flex flex-col gap-4 overflow-auto"
      v-if="isLoading || payments.length > 0"
    >
      <div
        v-for="(payment, index) in isLoading ? shimmerPayments : paymentsToShow"
        :key="index"
        :class="{ shimmerElement: payment.shimmer }"
        class="flex items-center justify-between py-0 rounded-2xl gap-8"
      >
        <!-- Product Info -->
        <div class="flex items-center gap-4 w-[16rem] min-w-[16rem]">
          <img
            :src="payment.image"
            :alt="payment.name"
            class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
          />
          <div class="w-[12rem]">
            <h3 class="text-lg font-bold title-color truncate">
              {{ payment.price }} FCFA
            </h3>
            <p class="truncate text-sm w-full">
              {{ payment.productName }}
            </p>
          </div>
        </div>

        <!-- Price and Quantity -->
        <div class="flex gap-6 w-[10rem] min-w-[10rem]">
          <div>
            {{ $Commons.timestampToDate(payment.date, 'DD MMM YYYY, HH:mm') }}
          </div>
        </div>

        <!-- Price and Quantity -->
        <div class="flex gap-6 w-[10rem] min-w-[10rem]">
          <div>
            {{ paymentMethods[payment.paymentMethod] }}
          </div>
        </div>

        <div class="flex flex-col items-center w-[6rem] min-w-[6rem]">
          <button
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
            :style="{
              backgroundColor: statuses[payment.status]?.background,
              color: statuses[payment.status]?.color,
            }"
          >
            {{ statuses[payment.status]?.name }}
          </button>
        </div>
        <div
          class="flex items-center gap-2 w-[3rem] min-w-[3rem] justify-end relative"
        >
          <DropdownComponent
            :selects="[
              {
                name: 'Copier la référence',
                onClick() {
                  $Commons.copy(payment.id || '-', 'Référence copiée')
                },
              },
              {
                name: 'Voir détails',
                onClick() {
                  $Events.dispatchEvent('payment_details_requested', payment)
                },
              },
            ]"
            hideArrow
            maxHeight="270px"
            displayKey="name"
            toLeft
            :onSelect="
              selected => {
                selected.onClick()
              }
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />
            </svg>
          </DropdownComponent>
        </div>
      </div>
    </div>

    <div
      class="h-[55vh] w-full flex-col items-center justify-center flex p-8"
      v-else
    >
      <div class="w-1/4">
        <img src="@/assets/images/empty/no-payment.png" alt="" />
      </div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun Paiement</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Vous n'avez enrégistré aucun <br />
          paiement pour le moment
        </div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <router-link to="/products" class="buttonComponent">
            Créer ou partager un produit
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '../utils/DropdownComponent.vue'
import DotLottieComponent from '../utils/DotLottieComponent.vue'

export default {
  name: 'homeComponent',
  components: { DataGetter, DropdownComponent, DotLottieComponent },
  data() {
    return {
      eventsIds: [],
      payments: [],
      activeTab: 'home',
      isLoading: true,
      shimmerPayments: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
  },
  computed: {
    paymentsToShow() {
      return this.payments.slice(0, 6)
    },
  },
}
</script>
